import ConcurrentLogoIcon from "../../../../../../../assets/svg/concurrent-logo-icon";
import HubspotLogoIcon from "../../../../../../../assets/svg/hubspot-logo-icon";
import FeatureRequestStarIcon from "../../../../../../../assets/svg/feature-request-star-icon";
import AddUserIcon from "../../../../../../../assets/svg/add-user-icon";
import PrismLogoPng from "../../../../../../../assets/images/prism-logo.png";
import PowerBiLogoPng from "../../../../../../../assets/images/power-bi-logo.png";
import PlaygroundIcon from "../../../../../../../assets/svg/playground-icon";
import VerbafloLogoIcon from "../../../../../../../assets/images/verbaflo-logo.png";
import SettingsIcon from "../../../../../../../assets/svg/settings-icon";

export type SystemName =
  | "concurrent"
  | "prism"
  | "hubspot"
  | "power-bi"
  | "feature-requests"
  | "new-user-access"
  | "verbaflo";

type IconType = React.FC<{ className?: string }> | string;

const CATEGORY_ICONS: Record<
  SystemName,
  { icon: IconType; iconClassName: string }
> = {
  concurrent: { icon: ConcurrentLogoIcon, iconClassName: "w-[30px] h-[26px]" },
  "power-bi": { icon: PowerBiLogoPng, iconClassName: "w-7 h-7 object-contain" },
  prism: { icon: PrismLogoPng, iconClassName: "w-7 h-7 object-contain" },
  hubspot: { icon: HubspotLogoIcon, iconClassName: "w-7 h-7" },
  "feature-requests": {
    icon: FeatureRequestStarIcon,
    iconClassName: "w-[25px] h-[25px]",
  },
  "new-user-access": {
    icon: AddUserIcon,
    iconClassName: "w-7 text-verba-blue dark:text-verba-blue-dk",
  },
  verbaflo: {
    icon: VerbafloLogoIcon,
    iconClassName: "w-7 h-7",
  },
};

export const getCategoryIcon = (categoryKey: string) =>
  CATEGORY_ICONS[categoryKey as SystemName] || {
    icon: PlaygroundIcon,
    iconClassName: "w-7 h-7 text-verba-blue dark:text-verba-blue-dk",
  };

export const getSystemIcon = (systemName: SystemName): IconType =>
  CATEGORY_ICONS[systemName]?.icon || AddUserIcon;

/**
 * Renders a 14×14 icon for the given system name label.
 * Accepts both normalized keys ("concurrent") and display labels ("Concurrent").
 */
export const renderSystemIcon = (label: string) => {
  const key = label?.toLowerCase().replace(/\s+/g, "-") as SystemName;
  const icon = CATEGORY_ICONS[key]?.icon || SettingsIcon;
  if (typeof icon === "string") {
    return (
      <img
        src={icon}
        alt={label}
        className="w-[14px] h-[14px] shrink-0 object-contain"
      />
    );
  }
  const IconComponent = icon;
  return (
    <IconComponent
      className={`w-[14px] h-[14px] shrink-0 ${
        key === "new-user-access"
          ? "text-verba-blue dark:text-verba-blue-dk"
          : "text-verba-indigo dark:text-verba-indigo-dk"
      }`}
    />
  );
};
